import React, { useEffect, useRef, useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, BACKEND_URL } from '../lib/api';
import { t } from '../lib/i18n';

const startDownload = () => {
  const a = document.createElement('a');
  a.href = `${BACKEND_URL}/api/downloads/catalogs.zip`;
  a.download = '';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

// Floating home-page button: downloads a ZIP with every current catalog as PDF (prepared server-side, polled while building).
export const DownloadAllButton = () => {
  const [prep, setPrep] = useState(null);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const check = async () => {
    try {
      const { data } = await api.get('/downloads/catalogs/status');
      if (data.ready) {
        setPrep(null);
        startDownload();
        toast.success(t('Téléchargement démarré'), { description: `${data.catalogs} ${t('catalogues')} · ${Math.max(1, Math.round(data.size / 1048576))} MB` });
        return;
      }
      setPrep({ done: data.done, total: data.total });
      timer.current = setTimeout(check, 2000);
    } catch {
      setPrep(null);
      toast.error(t('Téléchargement indisponible, veuillez réessayer'));
    }
  };

  return (
    <button type="button" onClick={() => !prep && check()} disabled={!!prep} aria-label={t('Télécharger tous les catalogues (PDF)')} title={t('Télécharger tous les catalogues (PDF)')} data-testid="download-all-catalogs"
      className="fixed z-[89] end-4 md:end-5 bottom-[calc(5.5rem+env(safe-area-inset-bottom))] md:bottom-24 h-12 md:h-11 min-w-12 md:min-w-0 rounded-full bg-[#E50914] text-white shadow-[0_10px_30px_rgba(229,9,20,0.45)] flex items-center justify-center gap-2 px-3.5 md:px-4 font-bold text-sm transition-transform hover:scale-105 disabled:hover:scale-100">
      {prep ? <Loader2 size={18} className="animate-spin" /> : <Download size={18} />}
      <span className={prep ? 'inline' : 'hidden md:inline'} data-testid="download-all-label">
        {prep ? `${t('Préparation')} ${prep.done}/${prep.total}` : t('Tous les catalogues (PDF)')}
      </span>
      {!prep && <span className="md:hidden text-xs">PDF</span>}
    </button>
  );
};

export default DownloadAllButton;
